import { HttpClient } from "@/App/services";
import { ITruck } from "@/Trucks/services";

export default {
  getData(emsAgencyId: String): Promise<Array<ITruck>> {
    return HttpClient.get({ path: `/emsAgencies/${emsAgencyId}/trucks?all=true` }).then(({ data }) => data);
  },
  insertData(emsAgencyId: String, payload: any) {
    return HttpClient.post({ path: `/emsAgencies/${emsAgencyId}/trucks`, data: payload });
  },
  updateData(emsAgencyId: String, recordId: String, payload: any) {
    return HttpClient.put(`/emsAgencies/${emsAgencyId}/trucks/${recordId}`, payload);
  }
};
